import React, { useState } from "react";
import { motion } from "framer-motion";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Textarea } from "./ui/textarea";
import { Button } from "./ui/button";
import { Heart } from "lucide-react";

export const ReadingForm = ({ t, onSubmit }) => {
  const [form, setForm] = useState({
    name: "",
    partner_name: "",
    birth_date: "",
    partner_birth_date: "",
    question: "",
  });

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const valid = form.name.trim() && form.partner_name.trim() && form.question.trim();

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="max-w-2xl mx-auto px-5 sm:px-8 py-14"
    >
      <div className="text-center mb-10">
        <h2 className="font-serif-display text-4xl sm:text-5xl gold-text mb-3">{t.form_title}</h2>
        <p className="text-muted-foreground">{t.form_sub}</p>
      </div>

      <div className="space-y-6 bg-card/60 border border-border rounded-2xl p-7 sm:p-9 card-glow">
        <div className="grid sm:grid-cols-2 gap-5">
          <div className="space-y-2">
            <Label className="text-sm text-foreground/80">{t.your_name}</Label>
            <Input data-testid="input-name" value={form.name} onChange={set("name")} placeholder={t.your_name_ph}
              className="bg-background/60 border-border focus:ring-primary focus:border-primary" />
          </div>
          <div className="space-y-2">
            <Label className="text-sm text-foreground/80">{t.partner_name}</Label>
            <Input data-testid="input-partner-name" value={form.partner_name} onChange={set("partner_name")} placeholder={t.partner_name_ph}
              className="bg-background/60 border-border focus:ring-primary focus:border-primary" />
          </div>
        </div>

        <div className="grid sm:grid-cols-2 gap-5">
          <div className="space-y-2">
            <Label className="text-sm text-foreground/80">{t.your_birth}</Label>
            <Input data-testid="input-birth" type="date" value={form.birth_date} onChange={set("birth_date")}
              className="bg-background/60 border-border focus:ring-primary focus:border-primary" />
          </div>
          <div className="space-y-2">
            <Label className="text-sm text-foreground/80">{t.partner_birth}</Label>
            <Input data-testid="input-partner-birth" type="date" value={form.partner_birth_date} onChange={set("partner_birth_date")}
              className="bg-background/60 border-border focus:ring-primary focus:border-primary" />
          </div>
        </div>
        <p className="text-xs text-muted-foreground/70 -mt-3">{t.birth_optional}</p>

        <div className="space-y-2">
          <Label className="text-sm text-foreground/80">{t.question}</Label>
          <Textarea data-testid="input-question" value={form.question} onChange={set("question")} placeholder={t.question_ph} rows={4}
            className="bg-background/60 border-border focus:ring-primary focus:border-primary resize-none" />
        </div>

        <Button
          data-testid="form-continue-btn"
          disabled={!valid}
          onClick={() => onSubmit(form)}
          className="w-full bg-primary text-primary-foreground hover:bg-primary/90 rounded-full py-6 text-base disabled:opacity-40"
        >
          <Heart className="w-4 h-4 mr-2" fill="currentColor" />
          {t.continue_btn}
        </Button>
      </div>
    </motion.div>
  );
};
